import { define } from 'type-r';
import Product from './product'
import Collection from './base'

@define
export class ProductVariantCollection<R extends ProductVariant = ProductVariant> extends Collection<R> {
}


@define
export default class ProductVariant extends Product {
    static Collection = ProductVariantCollection<ProductVariant>;    
}
